<template>
  <div class="banner grid">
    <button class="clear-connections btn btn-stretch btn-extra-round text-bold"
            v-if="isShowingLinks && hasActiveLinks({ interaction })"
            @click="clearConnections($event, null, interaction)">Limpar </button>

    <div class="grid-center">

   <div class="gpt">
      <div :id="bannerAdId" style="width: 300px; height: 250px"></div>
    </div>

      <button class="clear-connections btn btn-stretch btn-extra-round text-bold"
              v-if="isShowingLinks && hasActiveLinks"
              @click="clearConnections($event)">Limpar conexões</button>        
    </div>

 
    
    <div class="text-center grid-bottom">
      <button id="0"
              class="btn btn-stretch btn-extra-round text-bold"
              :style="buttonStyle(firstOption.estilo)"
              ref="button"
              @click="(event) => showLinks({event,  interaction})">                 
        {{firstOption.nome}}
      </button>

      <button id="1"
              class="btn btn-stretch btn-extra-round text-bold second"
              v-if="options.length === 2"
              :style="buttonStyle(secondOption.estilo)"
              @click="(event) => showLinks({event,  interaction})">        
        {{secondOption.nome}}
      </button>
    </div>

  </div>
</template>

<script>
import AppImagePlaceholder from "../../ImagePlaceholder";
import buttonStyle from "../../../mixins/button-style";
import mode from "../../../mixins/mode";
import linkable from "../../../mixins/linkable";

export default {
  components: {
    AppImagePlaceholder,
  }, 

  props: {
    dataInteraction: {
      type: Object,
      required: true,
    },
  },


  data() {
    return {
      bannerAdId: `banner-ad-${Date.now()}`
    }
  },

  mounted() {
    this.initGoogleAd();
  },

  methods: {
    initGoogleAd() {
      window.googletag = window.googletag || { cmd: [] };

      googletag.cmd.push(() => {
        googletag.pubads().addEventListener('slotRenderEnded', function (event) {
          if (event.isEmpty) {
            googletag.cmd.push(() => {
              googletag.pubads().refresh();
            });
          }
        });
      });
    
      googletag.cmd.push(() => {
          googletag
              .defineSlot("/6355419/Travel/Europe/France/Paris", [300, 250], this.bannerAdId)
              .addService(googletag.pubads());
              
          googletag.enableServices();
      });

      googletag.cmd.push(() => {
        googletag.display(this.bannerAdId);
      });
    }
  },

  computed: {
    options() {
      return this.dataInteraction.opcoes;
    },

    firstOption() {
      return (
        this.options[0] || {
          estilo: null,
          nome: null,
        }
      );
    },

    secondOption() {
      return (
        this.options[1] || {
          estilo: null,
          nome: null,
        }
      );
    },

    itemStyle() {
      return this.dataInteraction.estilo ? this.dataInteraction.estilo : null
    },

    backgroundType() {
      return this.itemStyle ? this.itemStyle.backgroundType : null
    },
   
  },

  mixins: [buttonStyle, mode, linkable],
};
</script>

<style lang="scss" scoped>
@import "~@variables";

.banner {


  .gpt {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100%;
  }

  &.grid {
    .grid-center{
      margin: 0 auto;
    }
    .grid-bottom {
      gap: 2.5%;
      margin: 0 2.5%;
    }

    .btn {
      &.clear-connections {
        font-size: 14px;
        position: fixed;
        bottom: 15px;
        left: 40%;
        min-width: 0 !important;
        width: 20% !important;
        background-color: #2a7155;
        z-index: 10000;
        color: white;
        min-width: 0;

        &:hover {
          transform: translateY(-1px);
        }

        &:active {
          transform: translateY(1px);
        }
      }
    }
  }
}
</style>
